import { z } from "zod";

const releaseSchema = z.object({
  id: z.string().regex(/^[a-f0-9]{40}$/),
  short: z.string().regex(/^[a-f0-9]{7}$/),
  title: z.string(),
});

export const versionPreviewManifestSchema = z.object({
  switching: z.boolean(),
  current: releaseSchema,
  previous: releaseSchema.nullable(),
  unavailable: z.enum(["disabled", "incompatible", "buildFailed"]).nullable(),
  messages: z.object({
    nl: z.record(z.string(), z.string()),
    en: z.record(z.string(), z.string()),
  }),
});

export const versionPreviewConfigSchema = versionPreviewManifestSchema.extend({
  version: z.enum(["current", "previous"]),
  basePath: z.string(),
  current: releaseSchema.extend({ origin: z.string() }),
  previous: releaseSchema.extend({ origin: z.string() }).nullable(),
});

export type VersionPreviewManifest = z.infer<typeof versionPreviewManifestSchema>;
